export default __webpack_public_path__ + "static/media/apple-touch-icon-144x144.2e373a50.png";